<h2 mat-dialog-title>Search Patient</h2>

<mat-dialog-content>
  <p class="dialog-description">Search by name, UHID, or phone number.</p>

  <!-- Search Input -->
  <div class="search-container">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search</mat-label>
      <input
        matInput
        [(ngModel)]="searchText"
        placeholder="Enter name, UHID or phone..."
        (keyup.enter)="handleSearch()"
      />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
    <button
      mat-raised-button
      color="primary"
      (click)="handleSearch()"
      [disabled]="isSearching"
      class="search-button"
    >
      @if (isSearching) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        Search
      }
    </button>
  </div>

  <!-- Results Table -->
  <div class="results-container">
    @if (filteredPatients.length === 0 && !isSearching) {
      <p class="no-results">No patients found.</p>
    } @else {
      <table mat-table [dataSource]="filteredPatients" class="patients-table">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let patient">{{ patient.name }}</td>
        </ng-container>

        <!-- UHID Column -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>UHID</th>
          <td mat-cell *matCellDef="let patient">{{ patient.code }}</td>
        </ng-container>

        <!-- Phone Column -->
        <ng-container matColumnDef="contactNumber">
          <th mat-header-cell *matHeaderCellDef>Phone</th>
          <td mat-cell *matCellDef="let patient">{{ patient.contactNumber }}</td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let patient">
            <button
              mat-raised-button
              color="accent"
              (click)="selectPatient(patient)"
              class="select-button"
            >
              Select
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
